module.exports = __webpack_public_path__ + "img/chewei.c452137b.jpg";